import { Component, Input } from '@angular/core';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventManager } from '../../../../../../core/managers/event.manager';
import { CalculationEventEnum } from '../../../../../../core/enums/calculation-event.enum';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {
  IncomeTaxPersonalChildCampOptions,
} from '../../../../../../../../../../../common/src/options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';


@Component({
  selector: 'app-salary-dividend-personal-tax-child-camps-form',
  templateUrl: './salary-dividend-personal-tax-child-camps-form.component.html',
  styleUrls: ['./salary-dividend-personal-tax-child-camps-form.component.scss'],
  standalone: false,
})
export class SalaryDividendPersonalTaxChildCampsFormComponent {

  @Input()
  camps: AdvancedFormArray<IncomeTaxPersonalChildCampOptions>;
  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  constructor(public modalService: NgbModal, private readonly eventManager: EventManager) {

  }

  async removeCamp(campIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent, {});
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette colonie de vacance';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.camps.delete(campIndexToRemove);
        // Re-validate so the error list no longer references the removed camp's index.
        this.eventManager.publishEvent(CalculationEventEnum.FormArrayItemDeleted);

        return;
      }
    });

    return;
  }

  addCamp() {
    this.camps.appendNew();
  }
}
